import styled from 'styled-components';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';
import { RawButton } from '../Button/Button.styles';

interface SimpleTabProps extends MarginProps {
  isActive?: boolean;
}

export const SimpleTab = styled(RawButton)<SimpleTabProps>(
  ({ theme, isActive }) => ({
    fontFamily: theme.fontFamily,
    fontWeight: theme.fontWeights[500],
    fontSize: theme.fontSizes.body,
    transition: 'background ease-in-out 120ms',
    color: isActive ? theme.colors.primary['700'] : theme.colors.neutral['600'],
    background: isActive ? theme.colors.primary['100'] : 'transparent',
    padding: '10px 12px',
    borderRadius: theme.radii.medium,

    '&:not(.disabled):focus': {
      background: isActive ? theme.colors.primary['100'] : 'transparent',
    },

    '&&:hover': {
      color: isActive ? theme.colors.primary['700'] : theme.colors.neutral['700'],
      background: isActive ? theme.colors.primary['200'] : theme.colors.neutral['200'],
    },

    '&[data-focus-visible-added]:not(.disabled):focus': {
      outline: 'none',
      boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
      zIndex: 1,
    },
  }),

  margin,
);
